import { render } from "./SuccessfulPayment.vue?vue&type=template&id=b447793a&scoped=true"
import script from "./SuccessfulPayment.vue?vue&type=script&lang=js"
export * from "./SuccessfulPayment.vue?vue&type=script&lang=js"

import "./SuccessfulPayment.vue?vue&type=style&index=0&id=b447793a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b447793a"]])

export default __exports__